import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/Navigation/Buttons/WishlistButton/wishlistButton.container"
    ).then((module) => ({
        default: module.WishlistButton
    }))
);
